module.exports = __webpack_public_path__ + "img/headphone.0cfbaad3.svg";